export default __webpack_public_path__ + "static/media/blog_2.122ac48f.png";